// Whether AI-derived features (e.g. sentiment) may be shown to the current user.
// Restricted for specific customer domains for contractual reasons; the backend
// exposes the restriction on window.current_user (see ApplicationHelper#current_user_setup).
const aiFeaturesEnabled = () => !window.current_user?.ai_features_restricted;

export { aiFeaturesEnabled };
